import React from 'react';
import { Button, ButtonVariant } from '@patternfly/react-core';
import { useTranslation } from 'localization/useTranslation';
import Icons, { Size } from 'components/Common/Icons';
import useLogoutHandler from 'components/Authorization/useLogoutHandler';

export const SignOutButton = () => {
  const logout = useLogoutHandler();
  const T = useTranslation();
  return (
    <Button
      onClick={logout}
      variant={ButtonVariant.plain}
    >
      <div style={{ color: 'white', display: 'inline-flex', alignItems: 'center' }}>
        <Icons.Logout size={Size.LARGE}/>
        { T.common.logout }
      </div>
    </Button>
  );
};
